
import { Component, Vue } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import moment from "moment";
import DatePicker from "@/components/DatePicker.vue";

@Component({
	components: {
		DatePicker,
	},
})
export default class MwstAbrechnungView extends Vue {
	private loading: boolean = false;
	private region: string = "Deutschland";
	private regions: any = ["Deutschland", "Österreich", "Schweiz/Liechtenstein"];
	private createInvoicePdf: boolean = false;
	private startDate: string = moment().subtract(5, "days").format("YYYY-01-01 00:00:00");
	private endDate: string = moment(moment(this.startDate).format("YYYY-MM-01 00:00:00"))
		.add(3, "month")
		.subtract(1, "days")
		.format("YYYY-MM-DD 23:59:59");

	private mounted() {
		this.region = this.regions[0];
	}

	private get sanitizedRegion() {
		return this.region.replace("/", "-");
	}

	private async getMwstAbrechnung() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetMwstData?regionName=${this.region}&von=${this.startDate}&bis=${this.endDate}&createInvoicePdf=${this.createInvoicePdf}`,
				{
					responseType: "blob",
				}
			);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute(
				"download",
				`MwST Unterlagen ${this.sanitizedRegion} vom ${moment(this.startDate).format("DD.MM.YYYY")} bis ${moment(this.endDate).format("DD.MM.YYYY")}.zip`
			);
			link.click();
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				"Mwst Abrechnung konnte nicht heruntergeladen werden."
			);
		} finally {
			this.loading = false;
		}
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD");
	}
	private setEndDate(date: Date) {
		this.endDate = moment(date).format("YYYY-MM-DD");
	}
}
